import {
    CHART_DESKTOP_MARGIN,
    CHART_DESKTOP_SPACING,
    CHART_DESKTOP_WIDTH,
    CHART_MOBILE_MARGIN,
    CHART_MOBILE_SPACING,
    CHART_MOBILE_WIDTH,
    FONT_SIZE,
} from "./constants";
import styles from "./Weather.module.scss";

const labelHeight = 36;

const monthsLong = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];

const monthsAbbr = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];

export const ChartMonthLabels: React.FC = () => {
    return (
        <>
            <svg
                viewBox={`0 0 ${CHART_DESKTOP_WIDTH} ${labelHeight}`}
                className={styles.desktop}
            >
                <g>
                    {monthsLong.map((month, x) => (
                        <text
                            textAnchor="middle"
                            key={month}
                            x={CHART_DESKTOP_SPACING * x + CHART_DESKTOP_MARGIN}
                            y={labelHeight - FONT_SIZE}
                            fontSize={FONT_SIZE}
                            fontWeight="var(--g-font-weight-regular)"
                            fontFamily="var(--g-font-family-primary)"
                            fill="currentColor"
                        >
                            {month}
                        </text>
                    ))}
                </g>
            </svg>
            <svg
                viewBox={`0 0 ${CHART_MOBILE_WIDTH} ${labelHeight}`}
                className={styles.mobile}
            >
                <g>
                    {monthsAbbr.map((month, x) => (
                        <text
                            textAnchor="middle"
                            key={`${month}_${x}`}
                            x={CHART_MOBILE_SPACING * x + CHART_MOBILE_MARGIN}
                            y={labelHeight - FONT_SIZE}
                            fontSize={FONT_SIZE}
                            fontWeight="var(--g-font-weight-regular)"
                            fontFamily="var(--g-font-family-primary)"
                            fill="currentColor"
                        >
                            {month}
                        </text>
                    ))}
                </g>
            </svg>
        </>
    );
};
